import { useCallback } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import { SignMailStatus } from 'features/signmail/enums';
import {
  changeSignMailStatus,
  endSignMailSession,
  startSignMailCountdown,
  startSkippedSignMailSession,
} from 'features/signmail/store';
import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { useCallDeafParticipantHandlers } from 'features/call/call-accepted/hooks';

export const useSignMailHandlers = () => {
  const dispatch = useAppDispatch();
  const { handleDeafCancel } = useCallDeafParticipantHandlers();

  const handleEndSignMailSession = useCallback(() => {
    dispatch(endSignMailSession());
  }, [dispatch]);

  const handleCountdownEnded = () => {
    dispatch(changeSignMailStatus(SignMailStatus.RECORDING));
  };

  const handleSkipToSignMail = useCallback(() => {
    handleDeafCancel();
    const didStart = dispatch(startSkippedSignMailSession());
    if (!didStart) {
      dispatch(
        sendAnalyticsInfo({
          Method: 'handleSkipToSignMail',
          message:
            'Cant start new signmail session. AST owns SignMail or a session is already in progress.',
          LogGroup: 'SignMail',
        })
      );
      return;
    }
    dispatch(
      sendAnalyticsInfo({
        Method: 'handleSkipToSignMail',
        message:
          'Agent skipped to signmail using skip button. Signmail session started.',
        LogGroup: 'SignMail',
      })
    );
  }, [dispatch, handleDeafCancel]);
  const handleGreetingEnded = useCallback(() => {
    dispatch(startSignMailCountdown());
  }, [dispatch]);

  return {
    handleEndSignMailSession,
    handleGreetingEnded,
    handleCountdownEnded,
    handleSkipToSignMail,
  };
};
